module.exports = "td{\r\n    border: 1px solid #ccc\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing/unify-marketing-grid/unify-marketing-grid.component.css
// module id = ./src/app/prospect/unify-marketing/unify-marketing-grid/unify-marketing-grid.component.css
// module chunks = main